/*
  This component renders a list of items that are vertically divided by gray borders,
  as well as an optional set of headers for the items.

  The item type must be a React component that accepts the children of
  a ListWithDividers item as props.

  Ref: https://w.amazon.com/bin/view/Goodreads/Teams/Mobile_web/Responsive_SeriesList_Components_Refactor/
*/

import Hash from "object-hash";
import { PropTypes } from "react";

const ListWithDividers = ( { ItemComponentType, items, itemHeaders } ) => {

  const itemsArray = items.map((item, idx) => {

    const itemHeader = itemHeaders && itemHeaders[idx] ?
      <h3 className="gr-h3 gr-h3--noBottomMargin">
        {itemHeaders[idx]}
      </h3>
      : null;

    return (
      <div className="listWithDividers__item" key={Hash(item)}>
        { itemHeader }
        <ItemComponentType { ...item } />
      </div>
    );
  });

  return(
    <div className="listWithDividers">
      { itemsArray }
    </div>
  );
};

ListWithDividers.propTypes = {
  ItemComponentType: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  itemHeaders: PropTypes.array,
};

export default ListWithDividers;
